/* Header (§8.2): mega menus (150ms hover intent, click/Enter on the toggle, Esc closes),
   hide on scroll down / show on scroll up, html.is-scrolled for the announcement bar,
   and the bag bump when the cart changes. */
class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-header-bar]');
    this.bag = this.querySelector('.hdr__bag');
    this.items = [...this.querySelectorAll('[data-menu-item]')];
    this.hideOnScroll = this.hasAttribute('data-hide-on-scroll');
    this.lastY = window.scrollY;
    this.timers = new Map();

    this.items.forEach((item) => {
      const toggle = item.querySelector('[data-menu-toggle]');
      item.addEventListener('pointerenter', (event) => event.pointerType === 'mouse' && this.intent(item, true));
      item.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && this.intent(item, false));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.setOpen(item, false);
      });
      toggle.addEventListener('click', () => {
        clearTimeout(this.timers.get(item));
        this.setOpen(item, !item.classList.contains('is-open'));
      });
    });

    this.onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      const open = this.items.find((item) => item.classList.contains('is-open'));
      if (!open) return;
      this.setOpen(open, false);
      open.querySelector('[data-menu-toggle]').focus();
    };
    this.onScroll = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => this.handleScroll());
    };
    this.onDocumentClick = (event) => {
      if (!this.bar.contains(event.target)) this.closeAll();
    };
    this.onCartUpdated = () => this.bump();
    this.onBlockSelect = (event) => this.selectBlock(event, true);
    this.onBlockDeselect = (event) => this.selectBlock(event, false);

    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('cart:updated', this.onCartUpdated);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('cart:updated', this.onCartUpdated);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    window.removeEventListener('scroll', this.onScroll);
    this.timers.forEach(clearTimeout);
  }

  intent(item, open) {
    clearTimeout(this.timers.get(item));
    this.timers.set(item, setTimeout(() => this.setOpen(item, open), open ? 150 : 220));
  }

  setOpen(item, open) {
    if (open) this.items.forEach((other) => other !== item && other.classList.contains('is-open') && this.setOpen(other, false));
    item.classList.toggle('is-open', open);
    item.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', String(open));
    this.bar.classList.toggle('is-mega', this.items.some((i) => i.classList.contains('is-open') && i.querySelector('.mega')));
    if (open) this.classList.remove('is-hidden');
  }

  closeAll() {
    this.items.forEach((item) => item.classList.contains('is-open') && this.setOpen(item, false));
  }

  // Theme editor: selecting a mega menu block opens its panel.
  selectBlock(event, open) {
    const item = this.items.find((i) => i.contains(event.target));
    if (item) this.setOpen(item, open);
  }

  handleScroll() {
    this.frame = 0;
    const y = window.scrollY;
    document.documentElement.classList.toggle('is-scrolled', y > 8);
    if (!this.hideOnScroll) return;
    const delta = y - this.lastY;
    if (Math.abs(delta) < 6) return;
    // Never hide while a menu is open, focus is inside the header, or a drawer has locked scrolling.
    const busy =
      this.items.some((item) => item.classList.contains('is-open')) ||
      this.contains(document.activeElement) ||
      document.documentElement.classList.contains('is-locked');
    this.classList.toggle('is-hidden', !busy && delta > 0 && y > 140);
    this.lastY = y;
  }

  bump() {
    if (!this.bag) return;
    this.bag.classList.remove('is-bump');
    void this.bag.offsetWidth;
    this.bag.classList.add('is-bump');
  }
}

if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
